export var FEATURE_FLAG = "EnableInlineHelp";
export var TEXT_TYPE = "text";
export var KEY_TERM_TYPE = "keyTerm";
export var IMAGE_TYPE = "image";
export var VIDEO_TYPE = "video";
export var LINK_TYPE = "link";
export var HEADER = "header";
export var OVERVIEW = "overview";
export var KEY_HEADING = "keyTerminology";
export var FOOTER = "footer";
export default FEATURE_FLAG;

//# sourceMappingURL=common.js.map